import { ReactNode } from 'react';
import styled from 'styled-components';

import { IconDefinition } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { Text16 } from 'atoms/typography';
import { Color } from 'style/types';

import PaymentMethodIcon from '../Icon';

const Row = styled(Horizontal).attrs({ gap: 1.5 })``;

const Text = styled.div`
  color: var(--c-brand-600);
`;
const Balance = styled.div`
  display: flex;
  gap: var(--unit);
`;

type Props = {
  icon: IconDefinition;
  color: Color;
  label: ReactNode;
  balance: ReactNode;
  withoutBalance?: boolean;
};

export const SorareWallet = ({
  icon,
  label,
  balance,
  withoutBalance,
  color = 'var(--c-brand-600)',
}: Props) => {
  return (
    <Row>
      <PaymentMethodIcon
        backgroundColor={color}
        icon={icon}
        color="var(--c-neutral-1000)"
      />
      <Text>
        <Text16 color="var(--c-neutral-1000)">{label}</Text16>
        {!withoutBalance && <Balance>{balance}</Balance>}
      </Text>
    </Row>
  );
};

export default SorareWallet;
